import { Location } from '@angular/common';
import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';


@Component({
  selector: 'app-skills-tab',
  templateUrl: './skills-tab.component.html',
  styleUrls: ['./skills-tab.component.scss']
})
export class SkillsTabComponent implements OnInit {

  constructor(private personSearchService: PersonSearchService, private location: Location, private companyinsightsService: CompanyInsightsService, private localStorageService: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private hashService: HashService) { }
  companyDetails: any;
  currentCompanyName: any;
  skills: any;
  skillsData: any = [];
  displayedColumns: string[] = ['key', 'doc_count', 'graph'];
 // @ViewChild('skillsTbSort') skillsTbSort: MatSort;
  @ViewChild(MatSort) sort: MatSort;

  totalResultCount: number = 0;
  startindex: number = 0;
  aggregatescount: number = 50;
  topFiveSkills: any = [];
  alternatecompanyNames: any[] = []

  /** start index in page */
  start: number = 0;
  /**End index in page */
  end: number = 10;
  /**Number of items on each of page */
  pageSize:number = 10;
  /**Current page number */
  currentPage: number = 1;
  /**Total items */
  totalCount = 0;

  skillsubscription: Subscription;
  skillemptystate: Boolean = false;
  skilldataforsort: any;
  initialSortColumns: string[] = ['doc_count', 'graph'];
  skillsdataAI: any = {}
  /** Subscription var */
  subscriptions: Array<Subscription> = [];
  companyinsightsFilter: any = {};

  insightsExportSubscription: Subscription = null;

  ngOnInit(): void {
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.setCompanyDetails();
    this.fetchPageData();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.fetchPageData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  fetchPageData() {
    this.getSkills();
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

  }

  getSkills() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "skills";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.totalResultCount = response.data.totalresultscount;
      const tempData = response.data.aggregations.skills;
      this.totalCount = tempData.length;
      this.skilldataforsort = tempData
      this.skillsData = tempData.slice(this.start, this.end);
      this.skills = new MatTableDataSource(this.skillsData);
      this.skills.sort = this.sort;
      this.manualSort();
      this.getskillsdataai(this.skilldataforsort)
   
      this.topFiveSkills = tempData.slice(0, 5);
      this.skillemptystate = true;
    });
  }



  getSkillPercentage(value) {
    return ((value / this.totalResultCount) * 100).toFixed(2);
  }

  /**
   * Function set the start and end of aggreggate datat according to page number
   * @param index page number in pagination
   */
  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if(this.aggregatescount / this.pageSize <= index){ 
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getSkills();
    }
    else{
      this.manualSort();
    }
  }

  /**
   * Sort the array
   * 
   */
  manualSort() {
    this.reSortArray(this.sort);
  }

  /**
   * Re-sort the array
   * @param {MatSort} sort
   */
  private reSortArray(sort: MatSort) {
    const data = this.skilldataforsort;
    if (!sort|| !sort.active || sort.direction === '') {
      this.skillsData = data.slice(this.start, this.end);
      this.skills = new MatTableDataSource(this.skillsData);
      return;
    }

    this.skilldataforsort = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'graph': return this.compare(a.doc_count, b.doc_count, isAsc);
        default: return 0;
      }
    });
    this.skillsData = this.skilldataforsort.slice(this.start, this.end);
    this.skills = new MatTableDataSource(this.skillsData);
  }

  private compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
   * destroy subscriptions of filters
   */
   ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'skills') return;

    const payloadForInsightsExport: ExportPayload = {
      tab: 'skills',
      companydetails: this.companyDetails,
      totalresultcount: this.totalResultCount,
      skills: this.skilldataforsort
    }
    this.companyinsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    const additionalFilters = {};
    switch(type) {
      case 'skills': additionalFilters['mandatoryskills'] = [key]; break;
    }

    this.companyinsightsFilter['additionalFilters'] = additionalFilters;
    this.companyinsightsFilter['name'] = this?.companyDetails?.name;
    this.companyinsightsFilter['alternative_names'] = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]): [this.currentCompanyName];
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCompanyInsightsRedirection(uniqueHash, this.companyinsightsFilter);
    const requestObject = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=company-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH_COMPANY}=${uniqueHash}&keyword=${requestObject.booleanquery!= '*' ? requestObject.booleanquery: ''}`;
    window.open(url, "_blank");
  }

  getskillsdataai(data) {
    let skillsdata: any;
    skillsdata = data.map(x=>{
      let res: any ={};
      res['Top Skills'] = x.key;
      res['Talent Count'] = x.doc_count;
      res['% of Total'] = this.getSkillPercentage(x.doc_count)+'%';
      return res;
    
    })
    this.skillsdataAI = {
      skills: skillsdata
    }
    if(skillsdata.length == 0)
      this.skillsdataAI = null;
    
  }
}
